import {DOSSIER_STATE} from 'front-onceforall-core/dist/utils/dossiers';

import {startLoading} from '../../../utils/reducer';
import {deepCopy} from '../../../utils/arrays';

import {getTabItems, TAB_PATH, TAB_INDEXES} from '../Tabs/utils';

export function startLoadingImpl(state, keys) {
  const newState = startLoading(state, keys);
  keys.forEach(key => {
    const index = TAB_INDEXES[key];
    if (index !== undefined) {
      newState.tabItems[index].loading = true;
    }
  });
  return newState;
}

export const updateDocumentsTab = ({tabItems, documents}) => {
  const items = deepCopy(tabItems);
  items[TAB_INDEXES.documents].loading = documents.loading;
  items[TAB_INDEXES.documents].counter = documents.totalCount;
  return items;
};

export const updateUsersTab = ({tabItems, users}) => {
  const items = deepCopy(tabItems);
  items[TAB_INDEXES.users].loading = users.loading;
  items[TAB_INDEXES.users].counter = users.totalCount;
  return items;
};

export const updateProjectsTab = ({tabItems, interventions}) => {
  const items = deepCopy(tabItems);
  items[TAB_INDEXES.interventions].loading = interventions.loading;
  items[TAB_INDEXES.interventions].counter = interventions.totalCount;
  return items;
};

export const updateTabsLink = (tabItems, {organisationId}) => {
  const items = deepCopy(tabItems);
  for (let i = 0; i < items.length; i++) {
    items[i].link = `/client/${organisationId}${TAB_PATH[i]}`;
  }
  return items;
};

export const interventionsPageSize = 10;
export const usersPageSize = 25;

export const initialState = {
  tabItems: getTabItems(),
  client: {
    details: null,
    loading: true,
    error: false
  },
  documents: {
    list: [],
    loading: true,
    error: false
  },
  dossierState: {
    dossierState: DOSSIER_STATE.EMPTY,
    invalidDocuments: [],
    almostExpiredDocuments: [],
    loading: true,
    error: false
  },
  interventions: {
    list: [],
    loading: true,
    error: false,
    totalCount: 0,
    pageSize: interventionsPageSize
  },
  users: {
    list: [],
    loading: true,
    error: false,
    totalCount: 0,
    pageSize: usersPageSize
  }
};
